import { useParams } from "react-router-dom";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "../firebase";

function BlogPost() {
  const { id } = useParams();
  const [post, loading, error] = useDocumentData(doc(db, "posts", id));

  // Log for debugging
  console.log("BlogPost render, post:", post, "error:", error?.message);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-16">
        <div className="flex justify-center items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" aria-label="Loading" />
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-text-light dark:text-text-dark mb-6">
          Post Not Found
        </h1>
        <div className="card p-6">
          <p className="text-lg text-neutral">
            Sorry, this blog post could not be found.
            {error && ` Error: ${error.message}`}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-text-light dark:text-text-dark mb-6">
        {post.title}
      </h1>
      <p className="text-sm text-neutral mb-4">{post.date?.toDate().toISOString().split('T')[0]}</p>
      <div
        className="card p-6"
        dangerouslySetInnerHTML={{ __html: post.content.replace(/\n/g, '<br>') }}
      />
    </div>
  );
}

export default BlogPost;